module.exports = __webpack_public_path__ + "media/app/images/spotify-40e18927085444d4788c3eb545e88e8c.png";